import axios from "axios";
import { useEffect, useState } from "react";


const CuratedTrendProductsUpload = () => {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isUploading, setIsUploading] = useState(false);


  const [selectIdToDelete, setSelectIoToDelete] = useState('')
  const [allFiles, setAllFiles] = useState([])

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && (selectedFile.type === "text/csv" || selectedFile.name.endsWith('.csv'))) {
      setFile(selectedFile);
      setStatus({ type: 'info', message: `Ready to upload: ${selectedFile.name}` });
    } else {
      setFile(null);
      setStatus({ type: 'error', message: "Please select a valid CSV file." });
    }
  };

  useEffect(() => {
    getAllFileNames()
  }, [])

  const getAllFileNames = async () => {
    const response = await axios.get('/api/curated-trend-products/filenames');
    setAllFiles(response.data.files)

  }

  const deleteFile = async () => {
    const response = await axios.delete(`/api/curated-trend-products/filename?id=${selectIdToDelete}`)
    setSelectIoToDelete('')
    getAllFileNames()
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;

    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post('/api/curated-trend-products/csv-upload', formData);

      if (response.data && response.data.message == 'Upload successful' && response.data.recordsProcessed > 0) {
        setStatus({ type: 'success', message: "Products added successfully!" });
        setFile(null);
      } else if (response.data && response.data.recordsProcessed == 0) {

        setStatus({ type: 'error', message: " 0 Products added. CSV headers do not match." });
      } else {
        setStatus({ type: 'error', message: "Server error. Please try again." });
      }
    } catch (error) {
      setStatus({ type: 'error', message: "Network error. Check your connection." });
    } finally {
      setIsUploading(false);
    }
  };

  return (

    <>
      <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-xl shadow-md border border-slate-100">
        <div className="mb-6">
          <h2 className="text-xl font-bold text-slate-800">Upload Product CSV</h2>
          <p className="text-sm text-slate-500">Gender, Trend, Product ID, and Image Link</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative group">
            <label className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer transition-colors
            ${file ? 'border-blue-400 bg-blue-50' : 'border-slate-300 bg-slate-50 hover:bg-slate-100'}`}>

              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                <p className="text-sm text-slate-600">
                  <span className="font-semibold">Click to upload</span> or drag and drop
                </p>
                <p className="text-xs text-slate-400 mt-1">CSV files only</p>
              </div>

              <input
                type="file"
                className="hidden"
                accept=".csv"
                onChange={handleFileChange}
              />
            </label>
          </div>

          {/* Status Messages */}
          {status.message && (
            <div className={`flex items-center p-3 text-sm rounded-lg ${status.type === 'error' ? 'bg-red-50 text-red-700' :
              status.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-blue-50 text-blue-700'
              }`}>
              {status.message}
            </div>
          )}

          <button
            type="submit"
            disabled={!file || isUploading}
            className={`w-full py-2 px-4 rounded-lg font-medium transition-all
            ${!file || isUploading
                ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700 active:transform active:scale-[0.98]'}`}
          >
            {isUploading ? 'Processing...' : 'Upload CSV'}
          </button>
        </form>

      </div>

      <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-xl shadow-md border border-slate-100">
        <h2 className="text-center mt-10 font-semibold text-xl">Delete filenames</h2>
        <select className="p-1 rounded w-80 m-2" value={selectIdToDelete}
          onChange={e => {
            setSelectIoToDelete(e.target.value)
          }}
        >
          <option value={''} >Select CSV to delete</option>
          {allFiles.map(v => <option value={v._id}>{v.filename}</option>)}

        </select>
        <button
          className="btn-primary bg-red-400 px-2 hover:bg-red-500 text-white m-2"
          disable={selectIdToDelete != ''}

          onClick={
            () => {
              deleteFile()
            }
          }
        >Delete</button>

      </div>
    </>
  );
}

export default CuratedTrendProductsUpload
